<section>
    <div class="wrapper camera-form">
        <article class="mrt-75">
            <div class="row">
                <div class="col-8">
                    <div class="header">
                        <mat-icon aria-label="Home Page" style="cursor: pointer;"
                            routerLink="/dashboard">home</mat-icon>
                        <span class="backdrop-slash">&nbsp;/&nbsp;</span>
                        <a routerLink="/camera-server/camera-list" *ngIf="!isSitePage">Camera List</a>
                        <a routerLink="/camera-server/sitelist/{{sitePId}}"
                            *ngIf="!isFieldEnableDisable || editCameraFromSiteList">
                            Site List
                            <span class="backdrop-slash">&nbsp;/&nbsp;</span>
                            {{sitePId}}
                        </a>
                        <span class="backdrop-slash">&nbsp;/&nbsp;</span>
                        <span *ngIf="!isFieldEnableDisable">Add Camera</span>
                        <span *ngIf="isFieldEnableDisable">Edit Camera</span>
                        <span class="backdrop-slash">&nbsp;/&nbsp;</span>
                        <span>{{cameraInputForm.value.camName}}</span>
                    </div>
                </div>
                <div class="col-4">
                    <div class="whilelisted-section">
                        <div class="checkbox-whitelist" style="display: none;">
                            <mat-checkbox class="white-checkbox" name="whitelistedSite"
                                (change)="handleCheckWhitelisted($event)">Whitelisted Site</mat-checkbox>
                        </div>
                        <div class="{{whitelistedSite ? 'show-whitelistedapilist' :'hide-whitelistedapilist'}}"
                            style="display: none;">
                            <mat-form-field appearance="outline">
                                <mat-label class="">IP's List</mat-label>
                                <mat-select name="ipList">
                                    <mat-option *ngFor="let whiteIP of whitelistedIpList;"
                                        value="{{whiteIP.value}}">{{whiteIP.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <button mat-raised-button color="primary" class="edit-btn"
                            *ngIf="isFieldEnableDisable && selectedTabCamera === 1 && isCameraSettingFeature"
                            (click)="ManualSyncCamera()">
                            <mat-icon aria-label="Manual Sync Camera"
                                matTooltip="Manual Sync Camera Day/Night image">sync</mat-icon>
                        </button>
                        <button mat-raised-button color="primary" class="edit-btn" *ngIf="isFieldEnableDisable"
                            (click)="liveViewForSingleCamera($event)" matTooltip="Live View" style="margin-left: 5px;">
                            <mat-icon aria-hidden="false" aria-label="live view">play_arrow</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div class="header-tabs">
                <form [formGroup]="cameraInputForm">
                    <mat-tab-group class="tab-group" [(selectedIndex)]="selectedTabCamera"
                        (selectedIndexChange)="changeTab($event)">
                        <!-- Setting Tabs -->
                        <mat-tab label="Camera Settings">
                            <div class="camera-section">
                                <div class="fieldsetItem">
                                    <div class="legenditem">
                                        <h4 class="heading_text"> Camera</h4>
                                        <mat-grid-list cols="3" rowHeight="80px" class="header-grid">
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Camera Name</mat-label>
                                                    <input matInput placeholder="Camera Name" name="camName"
                                                        formControlName="camName">
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.cameraName}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Analytic Name</mat-label>
                                                    <mat-select name="camAnalyticName" formControlName="camAnalyticName"
                                                        readonly="isFieldEnableDisable">
                                                        <mat-option *ngFor="let anl_name of analytic_name;"
                                                            value="{{anl_name.value}}">{{anl_name.name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.analyticName}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Type</mat-label>
                                                    <mat-select formControlName="camType" name="camType"
                                                        (ngModelChange)="handleSelectType($event)">
                                                        <mat-option *ngFor="let type of type_data;"
                                                            value="{{type.value}}">{{type.name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.camType}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>IP / URL</mat-label>
                                                    <input matInput placeholder="IP / URL" name="camIpUrl"
                                                        formControlName="camIpUrl">
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.camIpUrl}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Username</mat-label>
                                                    <input matInput placeholder="Username" name="username"
                                                        formControlName="username">
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.username}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Password</mat-label>
                                                    <input matInput placeholder="Password" name="password"
                                                        formControlName="password"
                                                        [type]="hidePassword ? 'password' : 'text'">
                                                    <mat-icon matSuffix
                                                        (click)="hidePassword = !hidePassword">{{hidePassword ?
                                                        'visibility_off' : 'visibility'}}</mat-icon>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.password}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <!-- <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label class="asterix--before">Format</mat-label>
                                                    <mat-select name="format" formControlName="format">
                                                        <mat-option *ngFor="let frmt of format_data;"
                                                            value="{{frmt.value}}">{{frmt.name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.format}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile> -->
                                            <mat-grid-tile *ngIf="isHideCameraUniqueIdField">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Camera Unique ID</mat-label>
                                                    <input matInput placeholder="Camera Unique ID" name="camUniqueId"
                                                        formControlName="camUniqueId"
                                                        readonly="{{isFieldEnableDisable}}">
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.camUniqueId}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile class="" *ngIf="isCameraSettingFeature">
                                                <mat-form-field appearance="outline">
                                                    <mat-label class="">Camera Owned By</mat-label>
                                                    <mat-select name="cameraOwnedBy" formControlName="cameraOwnedBy">
                                                        <mat-option *ngFor="let camOwnVal of cameraOwnedList;"
                                                            value="{{camOwnVal.value}}">{{camOwnVal.name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.analyticName}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                        </mat-grid-list>
                                    </div>
                                </div>
                            </div>
                            <div class="misc-section">
                                <div class="fieldsetItem">
                                    <div class="legenditem">
                                        <h4 class="heading_text"> Misc</h4>
                                        <mat-grid-list cols="3" rowHeight="80px" class="header-grid" class="">
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Format</mat-label>
                                                    <mat-select name="format" formControlName="format">
                                                        <mat-option *ngFor="let frmt of format_data;"
                                                            value="{{frmt.value}}">{{frmt.name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.format}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile class="">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>COM Port No</mat-label>
                                                    <input matInput placeholder="COM Port No" type="number"
                                                        name="comPortNo" formControlName="comPortNo">
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.comPortNo}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile class="">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Feed Delay (SEC)</mat-label>
                                                    <input matInput placeholder="Feed Delay" name="feedDelay"
                                                        type="number" formControlName="feedDelay">
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.feedDelay}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile class="">
                                                <div class="checkbox-active">
                                                    <mat-checkbox class="active-checkbox" name="active"
                                                        formControlName="active" class="">Active</mat-checkbox>
                                                    <!-- <mat-error *ngIf="cameraInputForm.invalid">
                                                            {{errorMessageFormField.active}}
                                                        </mat-error> -->
                                                </div>
                                            </mat-grid-tile>
                                            <mat-grid-tile class="">
                                                <mat-form-field appearance="outline">
                                                    <mat-label class="">LPR Camera</mat-label>
                                                    <mat-select name="lprCamera" formControlName="lprCamera">
                                                        <mat-option *ngFor="let lprCam of lpr_camera_list;"
                                                            value="{{lprCam.value}}">{{lprCam.name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.lprCamera}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                        </mat-grid-list>
                                        <mat-grid-list cols="3" rowHeight="80px" class="header-grid" class="d-none">
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Supports PTZ</mat-label>
                                                    <mat-select name="supportPTZ" formControlName="supportPTZ">
                                                        <mat-option value=true>True</mat-option>
                                                        <mat-option value=false>False</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.supportPtz}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label class="">Address</mat-label>
                                                    <input matInput placeholder="Address" name="address"
                                                        formControlName="address" readonly="{{isFieldEnableDisable}}">
                                                    <!-- <mat-error
                                                    *ngIf="formControls.address.invalid && formControls.address.touched">
                                                    Please enter Address.
                                                </mat-error> -->
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Email ID</mat-label>
                                                    <input matInput placeholder="Email ID" formControlName="emailId"
                                                        type="email" name="emailId"
                                                        pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}">
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.email}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                        </mat-grid-list>
                                    </div>
                                </div>
                            </div>
                            <div class="motion-detection" class="d-none">
                                <div class="fieldsetItem">
                                    <div class="legenditem">
                                        <h4 class="heading_text"> Motion Detection</h4>
                                        <mat-grid-list cols="3" rowHeight="80px" class="header-grid">
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Method</mat-label>
                                                    <mat-select name="methods" formControlName="methods"
                                                        (selectionChange)="handleSelectMotionDetectionMethod($event)"
                                                        readonly="isFieldEnableDisable">
                                                        <mat-option *ngFor="let m_d_method of motion_detection_methods;"
                                                            value="{{m_d_method.value}}">{{m_d_method.name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.methods}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Sensitivity</mat-label>
                                                    <mat-select name="sensitivity" formControlName="sensitivity"
                                                        readonly="isFieldEnableDisable">
                                                        <mat-option
                                                            *ngFor="let m_d_sensitivity of motion_detection_sensitivity;"
                                                            value="{{m_d_sensitivity.val}}">{{m_d_sensitivity.val_name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.sensitivity}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile></mat-grid-tile>
                                        </mat-grid-list>
                                    </div>
                                </div>
                            </div>
                            <div class="Resolution-section">
                                <div class="fieldsetItem">
                                    <div class="legenditem">
                                        <h4 class="heading_text"> Resolution</h4>
                                        <mat-grid-list cols="3" rowHeight="80px" class="header-grid">
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Capture</mat-label>
                                                    <mat-select name="capture" formControlName="capture"
                                                        readonly="isFieldEnableDisable"
                                                        (ngModelChange)="handleSelectCapture($event)">
                                                        <mat-option *ngFor="let capReso of captureResolution;"
                                                            value="{{capReso.value}}">{{capReso.name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.capture}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Window Size View</mat-label>
                                                    <mat-select name="windowSizeView" formControlName="windowSizeView"
                                                        (ngModelChange)="handleSelectWindowSize($event)">
                                                        <mat-option *ngFor="let winSize of win_size_view;"
                                                            value="{{winSize.value}}">{{winSize.name}}</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.winSizeView}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>MAC Address</mat-label>
                                                    <input matInput name="macAddress" placeholder="MAC Address"
                                                        formControlName="macAddress">
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField?.macAddress}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <!-- <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label class="asterix--before">Compression</mat-label>
                                                    <mat-select name="compression" formControlName="compression"
                                                        readonly="isFieldEnableDisable">
                                                        <mat-option value="HIGH">High</mat-option>
                                                        <mat-option value="MEDIUM">Medium</mat-option>
                                                        <mat-option value="LOW">Low</mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="formControls.compression.invalid && formControls.compression.touched">
                                                        Please select Compression.
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile> -->
                                        </mat-grid-list>
                                        <mat-grid-list cols="3" rowHeight="80px" class="header-grid d-none">
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>MAC Address</mat-label>
                                                    <input matInput name="macAddress" placeholder="MAC Address"
                                                        formControlName="macAddress">
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.macAddress}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <!-- <div class="get-mac-address">
                                                    <button mat-raised-button class="get-mac-btn">Get MAC
                                                        Address</button>
                                                </div> -->
                                            </mat-grid-tile>
                                            <mat-grid-tile></mat-grid-tile>
                                        </mat-grid-list>
                                    </div>
                                </div>
                            </div>
                            <div class="FPS-Limitation">
                                <div class="fieldsetItem">
                                    <div class="legenditem">
                                        <h4 class="heading_text"> HD | SD URL's</h4>
                                        <mat-grid-list cols="3" rowHeight="100px" class="header-grid">
                                            <!-- <mat-grid-tile>
                                                <label class="asterix--before">No Motion</label>
                                                <mat-form-field appearance="outline" class="ml-3"
                                                    style="width: 38% !important;">
                                                    <mat-label>Frames</mat-label>
                                                    <mat-select name="noMotionsFrames"
                                                        formControlName="noMotionsFrames">
                                                        <mat-option value="1">1</mat-option>
                                                        <mat-option value="2">2</mat-option>
                                                        <mat-option value="3">3</mat-option>
                                                        <mat-option value="4">4</mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="formControls.noMotionsFrames.invalid && formControls.noMotionsFrames.touched">
                                                        Please select No Motion Frames.
                                                    </mat-error>
                                                </mat-form-field>
                                                <mat-form-field appearance="outline" class="ml-2"
                                                    style="width: 38% !important;">
                                                    <mat-label>Seconds</mat-label>
                                                    <mat-select name="noMotionSeconds"
                                                        formControlName="noMotionSeconds">
                                                        <mat-option value="1">1</mat-option>
                                                        <mat-option value="2">2</mat-option>
                                                        <mat-option value="3">3</mat-option>
                                                        <mat-option value="4">4</mat-option>
                                                        <mat-option value="5">5</mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="formControls.noMotionSeconds.invalid && formControls.noMotionSeconds.touched">
                                                        Please select No Motion Seconds.
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile> -->
                                            <mat-grid-tile>
                                                <div class="hdurl-field">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>HD URL</mat-label>
                                                        <input matInput placeholder="HD URL" name="hdUrl"
                                                            formControlName="hdUrl">
                                                        <mat-error *ngIf="cameraInputForm.invalid">
                                                            {{errorMessageFormField.hdUrl}}
                                                        </mat-error>
                                                    </mat-form-field>
                                                    <span *ngIf="cameraInputForm.get('hdUrl').hasError('whitespace')">
                                                        HD URL cannot contain whitespace
                                                    </span>
                                                </div>
                                                <button mat-icon-button (click)="RTSPHDUrlCheck()"
                                                    class="play-rtsp" matTooltip="HD RTSP URL Check">
                                                    <mat-icon aria-hidden="false"
                                                        aria-label="HD RTSP URL Check">play_arrow</mat-icon>
                                                </button>
                                            </mat-grid-tile>
                                            <!-- <mat-grid-tile>
                                                <label class="asterix--before">Motion</label>
                                                <mat-form-field appearance="outline" class="frame-feild"
                                                    style="width: 38% !important;">
                                                    <mat-label>Frames</mat-label>
                                                    <mat-select name="motionsFrames" formControlName="motionsFrames">
                                                        <mat-option value="1">1</mat-option>
                                                        <mat-option value="2">2</mat-option>
                                                        <mat-option value="3">3</mat-option>
                                                        <mat-option value="4">4</mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="formControls.motionsFrames.invalid && formControls.motionsFrames.touched">
                                                        Please select Motion Frames.
                                                    </mat-error>
                                                </mat-form-field>
                                                <mat-form-field appearance="outline" class="ml-2"
                                                    style="width: 38% !important;">
                                                    <mat-label>Seconds</mat-label>
                                                    <mat-select name="motionSeconds" formControlName="motionSeconds">
                                                        <mat-option value="1">1</mat-option>
                                                        <mat-option value="2">2</mat-option>
                                                        <mat-option value="3">3</mat-option>
                                                        <mat-option value="4">4</mat-option>
                                                        <mat-option value="5">5</mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="formControls.motionSeconds.invalid && formControls.motionSeconds.touched">
                                                        Please select Motion Seconds.
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile> -->
                                            <mat-grid-tile>
                                                <div class="hdurl-field">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>SD URL</mat-label>
                                                        <input matInput placeholder="SD URL" name="sdUrl"
                                                            formControlName="sdUrl">
                                                        <mat-error *ngIf="cameraInputForm.invalid">
                                                            {{errorMessageFormField.sdUrl}}
                                                        </mat-error>
                                                    </mat-form-field>
                                                    <span *ngIf="cameraInputForm.get('sdUrl').hasError('whitespace')">
                                                        SD URL cannot contain whitespace
                                                    </span>
                                                </div>
                                                <button mat-icon-button (click)="RTSPSDUrlCheck()"
                                                    class="play-rtsp" matTooltip="SD RTSP URL Check">
                                                    <mat-icon aria-hidden="false"
                                                        aria-label="SD RTSP URL Check">play_arrow</mat-icon>
                                                </button>
                                            </mat-grid-tile>
                                            <mat-grid-tile>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Monitoring type</mat-label>
                                                    <mat-select name="monitoringType" formControlName="monitoringType">
                                                        <mat-option value="true">Monitored</mat-option>
                                                        <mat-option value="false">Hosted</mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="cameraInputForm.invalid">
                                                        {{errorMessageFormField.monitoringType}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </mat-grid-tile>
                                            <mat-grid-tile class="" *ngIf="isFieldEnableDisable">
                                                <div class="copy-base-path">
                                                    <i *ngIf="!isFieldEnableDisable" class="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        matTooltip="After adding camera, base path url will be available"></i>
                                                    <div
                                                        [ngStyle]="{'background-color': !isFieldEnableDisable ? '#e8ebed':'', 'pointer-events':!isFieldEnableDisable?'none':''}">
                                                        <label>Copy Base Path URL : </label>
                                                        <i class="fa fa-copy  copy-icon" aria-hidden="true"
                                                            (click)="handleCopyBasePathUrl()"></i>
                                                        <div>Play this</div>
                                                        <a href="vlc://rtsp://root:60056005@10.66.4.40:557/axis-media/media.amp?videocodec=h264&resolution=320x240&fps=1">Open in VLC</a>
                                                    </div>
                                                </div>
                                            </mat-grid-tile>
                                        </mat-grid-list>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                        <!-- Description Tabs -->
                        <mat-tab label="Camera View">
                            <div class="description-area">
                                <mat-grid-list cols="2" rowHeight="{{desired_rowHeight}}" class="header-grid">
                                    <mat-grid-tile>
                                        <div class="view-area">
                                            <div class="image-preview-area">
                                                <div class="title">
                                                    <span>Day View</span>
                                                </div>
                                                <div class="imageview">
                                                    <img *ngIf="dayImageUrl !== '' " id="blah" src="{{dayImageUrl}}" />
                                                    <span *ngIf="dayImageUrl === '' ">No preview available</span>
                                                </div>
                                            </div>
                                            <div class="choose_file d-none" *ngIf="hasEditPrivilege">
                                                <mat-form-field class="w-full">
                                                    <input #fileDayInput type="file"
                                                        class="absolute top-0 z-10 h-full w-full cursor-pointer opacity-0"
                                                        accept=".jpeg,.jpg,.png" (change)="selectFileDayFile($event)" />
                                                    <mat-label>Choose file</mat-label>
                                                    <input matInput cdkFocusInitial class="z-0" appBlockCopyPaste
                                                        readonly />
                                                    <button mat-icon-button matSuffix (click)="fileDayInput.click()">
                                                        <mat-icon class="clouse_icons">cloud_upload</mat-icon>
                                                    </button>
                                                    <mat-hint class="mat-form-field-hint-end">JPEG / JPG /
                                                        PNG</mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </mat-grid-tile>
                                    <mat-grid-tile>
                                        <div class="view-area">
                                            <div class="image-preview-area">
                                                <div class="title">
                                                    <span>Night View</span>
                                                </div>
                                                <div class="imageview">
                                                    <img *ngIf="nightImageUrl !== '' " id="blah"
                                                        src="{{nightImageUrl}}" />
                                                    <span *ngIf="nightImageUrl === '' ">No preview available</span>
                                                </div>
                                            </div>
                                            <div class="choose_file d-none" *ngIf="hasEditPrivilege">
                                                <mat-form-field class="w-full">
                                                    <input #fileNightInput type="file"
                                                        class="absolute top-0 z-10 h-full w-full cursor-pointer opacity-0"
                                                        accept=".jpeg,.jpg,.png"
                                                        (change)="selectFileNightFile($event)" />
                                                    <mat-label>Choose file</mat-label>
                                                    <input matInput cdkFocusInitial class="z-0" appBlockCopyPaste
                                                        readonly />
                                                    <button mat-icon-button matSuffix (click)="fileNightInput.click()">
                                                        <mat-icon class="clouse_icons">cloud_upload</mat-icon>
                                                    </button>
                                                    <mat-hint class="mat-form-field-hint-end">JPEG / JPG /
                                                        PNG</mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </mat-grid-tile>
                                </mat-grid-list>
                            </div>
                            <mat-grid-list cols="1" rowHeight="300px" class="header-grid">
                                <mat-grid-tile>
                                    <div class="description-section">
                                        <mat-form-field>
                                            <mat-label>Description</mat-label>
                                            <textarea matInput placeholder="Description" [(ngModel)]="description"
                                                [ngModelOptions]="{standalone: true}" rows="10" name="description">
                                        </textarea>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                            </mat-grid-list>
                        </mat-tab>
                    </mat-tab-group>
                    <div class="camera-feild-btn">
                        <button mat-raised-button class="save-btn" *ngIf="isFieldEnableDisable && hasEditPrivilege"
                            (click)="updateCamera()">Save</button>
                        <button mat-raised-button *ngIf="!isFieldEnableDisable" class="save-btn"
                            (click)="addCamera()">Add</button>
                        <button mat-stroked-button class="test-btn" (click)="cancelOrBack()">Cancel</button>
                    </div>
                </form>
            </div>
        </article>
    </div>
</section>